import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
 
import { User } from '../models/user';

import { Observable } from 'rxjs'; 

import { catchError, tap } from 'rxjs/operators'; 
import { SharedServiceService } from './shared-service.service';
import { ControllerApiPath } from './constant';

@Injectable({
  providedIn: 'root'
})
export class ManageUserService {
  private apiBaseUrl:string;
  constructor(private http: HttpClient,private sharedService: SharedServiceService) { 
    this.apiBaseUrl = sharedService.baseUrl();
  }

  getUsersList(name: string = '', pageNo: number = 0, pageSize: number = 10, filterType: string = 'none', role: string = 'none', status: string = 'none'): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url =
      this.apiBaseUrl +
      ControllerApiPath.user +
      '?Name=' + encodeURIComponent(name) +
      '&PageNo=' + pageNo +
      '&PageSize=' + pageSize +
      '&filterType=' + encodeURIComponent(filterType) +
      '&role=' + encodeURIComponent(role) +
      '&status=' + encodeURIComponent(status);

    return this.http.get<any>(url, { headers });
  }

  getAllUsers(userType:any,status:any,pageSize:any,pageNumber:any = 1):Observable<any>{
    const headers = this.sharedService.createAuthorizationHeader();
    const url =
      this.apiBaseUrl +
      'users-webapi' +
      '?userType=' + encodeURIComponent(userType) +
      '&userStatus=' + encodeURIComponent(status) +
      '&pageSize=' + encodeURIComponent(pageSize) +
      '&pageNumber=' + encodeURIComponent(pageNumber);
    
    return this.http.get(url,{ headers });
  }

  createUser(user:User):Observable<any>{
    return this.http.post("url","");
  }

  inviteUser(payload: FormData): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.post(this.apiBaseUrl + ControllerApiPath.inviteUser, payload, { headers });
  }
  deleteUser(userId: string | number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.delete(this.apiBaseUrl + ControllerApiPath.deleteUser, { headers, params: { userId } });
  }
  getUserDetailsById(userId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.get(this.apiBaseUrl + ControllerApiPath.getUserDetailsById, { headers, params: { userId } });
  }
  updateUserDetails(userId: string, payload: FormData): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.put(this.apiBaseUrl + ControllerApiPath.updateUserDetails, payload, { headers, params: { userId } });
  }
  updateUserProfile(user:User,id:string){
    const headers = this.sharedService.createAuthorizationHeader();
    return  this.http.put<User>(this.apiBaseUrl + ControllerApiPath.user+'/'+id, user, { headers })
  }
  getUserbyId(id:any){
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.user+'/'+id;
    return this.http.get<User>(url,{ headers }).pipe(
      map((user: User) => {
        return user;
      })
    );
  }

  reIinviteUser(id:any){
    const headers = this.sharedService.createAuthorizationHeader();
     return  this.http.post(this.apiBaseUrl +ControllerApiPath.identity+'/re-inviteuser?userId='+id,[],{ headers }).pipe(
      map((response) => response),
      catchError((error) => {
        // Re-throw so the global error interceptor can show a toast (500/504/etc.).
        // Swallowing errors with of(1) made the UI show success when re-invite actually failed.
        throw error;
      }),
    )
  }

  
  
  getLoggedUser(){
    return this.sharedService.getLoggedInUser();
  }
 
}
